import React from 'react';
import { FiX, FiRotateCcw, FiTrash2 } from 'react-icons/fi';

interface ArchiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  routes: any[];
}

const ArchiveModal: React.FC<ArchiveModalProps> = ({ isOpen, onClose, routes }) => {
  if (!isOpen) return null;

  const handleRestore = (routeId: number) => {
    // TODO: Реализовать восстановление маршрута
    console.log('Restore route:', routeId);
  };

  const handleDelete = (routeId: number) => {
    // TODO: Реализовать удаление маршрута
    console.log('Delete route:', routeId);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden">
        {/* Заголовок */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Архив маршрутов</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Содержимое */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          {routes.length === 0 ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiTrash2 className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Архив пуст
              </h3>
              <p className="text-gray-600">
                В архиве пока нет маршрутов
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {routes.map((route) => (
                <div
                  key={route.id}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200"
                >
                  <div className="flex-1">
                    <h3 className="font-medium text-gray-900">{route.title}</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      Создан: {new Date(route.created_at).toLocaleDateString('ru-RU')}
                    </p>
                  </div>
                  
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => handleRestore(route.id)}
                      className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                      title="Вернуть из архива"
                    >
                      <FiRotateCcw className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => handleDelete(route.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      title="Удалить навсегда"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Подвал */}
        <div className="flex justify-end p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArchiveModal;
